import { IconSvgElement } from "@hugeicons/react";

export const PawPrintIcon: IconSvgElement = [
  [
    "path",
    {
      d: "M15.5803 13.6316C15.583 13.298 15.5397 12.9538 15.4407 12.6018C15.0571 11.2389 13.8907 10.1875 12.4916 9.96984C10.1981 9.61323 8.22133 11.3773 8.22133 13.6028V13.6107C8.22198 14.0322 8.04168 14.4465 7.67976 14.6621C6.48451 15.3753 5.72657 16.7434 5.91081 18.2741C6.10554 19.8919 7.39586 21.2214 9.00876 21.4574C9.8598 21.5819 10.6662 21.4141 11.3422 21.0398C11.6884 20.8477 12.1139 20.8484 12.4601 21.0398C13.1361 21.4141 13.9419 21.5812 14.7936 21.4574C16.4065 21.222 17.6968 19.8926 17.8915 18.2741C18.0758 16.7434 17.3172 15.3747 16.1213 14.6615C15.7652 14.4497 15.5771 14.0459 15.5803 13.6316Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      key: "0"
    }
  ],
  [
    "path",
    {
      d: "M10.3703 4.83652C10.6718 6.28262 10.1568 7.63695 9.21974 7.86114C8.28269 8.08533 7.27897 7.09483 6.97804 5.64807C6.67711 4.20132 7.19151 2.84765 8.12856 2.62345C9.0656 2.39926 10.0693 3.38977 10.3703 4.83652Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      key: "1"
    }
  ],
  [
    "path",
    {
      d: "M16.8254 5.64966C17.1268 4.20346 16.6116 2.84928 15.6746 2.625C14.7377 2.40073 13.7338 3.39129 13.4324 4.83749C13.131 6.28368 13.6463 7.63787 14.5832 7.86214C15.5202 8.08642 16.5241 7.09586 16.8254 5.64966Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      key: "2"
    }
  ],
  [
    "path",
    {
      d: "M6.05545 10.4329C6.5729 11.8069 6.27075 13.2333 5.38018 13.6181C4.48962 14.0029 3.3489 13.2012 2.83144 11.8265C2.31398 10.4519 2.61614 9.02611 3.5067 8.64131C4.39726 8.25652 5.53799 9.05823 6.05545 10.4329Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      key: "3"
    }
  ],
  [
    "path",
    {
      d: "M17.7475 10.4329C17.23 11.8069 17.5322 13.2333 18.4227 13.6181C19.3133 14.0029 20.454 13.2012 20.9715 11.8265C21.4889 10.4525 21.1868 9.02611 20.2962 8.64131C19.4056 8.25652 18.2649 9.05823 17.7475 10.4329Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      key: "4"
    }
  ]
];
